module.exports = __webpack_public_path__ + "../resources/img/ic_round_cancel.081d184f.svg";